const Loading = ()=>{

    return (
        <h1 className='loading'>Loading...</h1>
    )}

    export default Loading